import { combineReducers, configureStore } from '@reduxjs/toolkit';
import uiReducer from './slices/ui';
import userReducer from './slices/user';
import closedCaptionsReducer from './slices/closedCaptions';
import configReducer from './slices/config';
import modulesReducer from './slices/modules';
import baseReducer from './slices/plan';
import { buildUiStateMiddleware, } from './middleware/uiState';
import { buildUserStateMiddleware, } from './middleware/userState';
import pageDataReducer from './slices/pageData';
// ✅ Now we can safely define rootReducer without TypeScript complaining
const rootReducer = combineReducers({
    ui: uiReducer,
    user: userReducer,
    closedCaptions: closedCaptionsReducer,
    config: configReducer,
    modules: modulesReducer,
    plan: baseReducer,
    pageData: pageDataReducer,
});
// ✅ Explicitly set the return type to avoid TypeScript inferring 'UIState'
export function setupStore(adapters, preloadedState) {
    return configureStore({
        reducer: rootReducer,
        preloadedState,
        middleware: (getDefaultMiddleware) => getDefaultMiddleware()
            .prepend(buildUiStateMiddleware(adapters.onUiStateChange).middleware)
            .prepend(buildUserStateMiddleware(adapters.onUserStateChange).middleware),
    });
}
//# sourceMappingURL=store.js.map